
angular.module('clientDashboardApp.reviewBuilder').service('reviewDetailModal', function($uibModal, reviewGenService) {

  this.openById = function(reviewId, campaignId) {
    $uibModal.open({
      controller: modalCtrl,
      controllerAs: 'vm',
      template: require('./reviewDetailModal.html')
    });

    function modalCtrl() {
      this.review = null;
      reviewGenService.getReview(reviewId, campaignId)
        .then(review => this.review = review, error => this.review = {});
    }
  };

  this.open = function(review) {
    $uibModal.open({
      controller: modalCtrl,
      controllerAs: 'vm',
      template: require('./reviewDetailModal.html')
    });

    function modalCtrl() {
      this.review = review;
    }
  }

});
